import { AuthGuard } from '../../app.authGuard';
import { RunGuardsAndResolvers, Route } from '@angular/router';

import { ViewLayoutComponent } from './view-layout/view-layout.component';
import { OverviewDetailComponent } from './overview-detail/overview-detail.component';
import { UserDetailsComponent } from './user-details/user-details.component';

const options = {
  runGuardsAndResolvers: 'always' as RunGuardsAndResolvers
};

export let ViewInstitutionRouterModule: Route = {
  path: 'institution/view/:id', component: ViewLayoutComponent, children: [
    { path: 'overview', component: OverviewDetailComponent, canActivate: [AuthGuard] },
    { path: 'institutionUsers', component: UserDetailsComponent, canActivate: [AuthGuard] },
    { path: '', redirectTo: 'overview', pathMatch: 'full', canActivate: [AuthGuard] },
    { path: '**', redirectTo: 'overview', canActivate: [AuthGuard] }
  ]
};

